import { useReveal } from "@/hooks/useReveal";

const PRODUCTS = [
  {
    name: "Organic unrefined whole cane sugar",
    body: "Pulverised, granulated and single-serve sachet. Retail packs in 250g, 500g and 2.5 kg. Amber-gold, with a clean cane flavour and no bitterness.",
    tags: [
      "non-centrifugal cane sugar (NCS)",
      "whole cane sugar",
      "unrefined cane sugar",
      "muscovado-type",
      "jaggery",
      "panela (Latin America)",
    ],
    img: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/0bd02df4-4062-49fd-b218-94ff887b3157_compressed_organic-unrefined-whole-cane-sugar-3.webp",
    alt: "Amber-gold organic unrefined whole cane sugar in a kraft pouch",
  },
  {
    name: "Organic cocoa powder",
    body: "Pure cocoa powder at 15% fat, no added sugar, stable specification batch to batch. Retail packs in 250g and 600g. Cocoa butter, nibs and cocoa shell available on request.",
    tags: ["15% fat", "No added sugar", "Batch CoA"],
    img: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/b58550ea-1848-4832-865a-44eee513d346_compressed_organic-cocoa-powder.webp",
    alt: "Organic cocoa powder in a bowl beside a kraft pouch",
  },
];

export default function TheRange() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="range" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            The range
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            Two products, retail-ready, from the same production run and the
            same container.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {PRODUCTS.map((product) => (
            <div
              key={product.name}
              className="bg-cream rounded-lg overflow-hidden border border-cream-dark/60 flex flex-col"
            >
              <div className="h-[260px] md:h-[300px] overflow-hidden">
                <img
                  src={product.img}
                  alt={product.alt}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-7 md:p-8 flex-1 flex flex-col">
                <h3 className="text-ink font-serif text-xl md:text-2xl font-semibold">
                  {product.name}
                </h3>
                <p className="mt-3 text-ink/70 text-[17px] leading-relaxed">
                  {product.body}
                </p>
                <div className="mt-5 pt-4 border-t border-cream-dark/60">
                  <span className="text-ink/50 text-xs uppercase tracking-wider font-semibold">
                    Also known as:
                  </span>
                  <div className="mt-2 flex flex-wrap gap-2">
                    {product.tags.map((tag) => (
                      <span
                        key={tag}
                        className="whitespace-nowrap inline-flex items-center px-3 py-1 rounded-full bg-white border border-cream-dark/70 text-ink/70 text-xs"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-ink/60 text-sm">
          Specialty coffee, herbal infusions and spices are available to fill
          out a mixed container.
        </p>
      </div>
    </section>
  );
}